import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ValidationConstraint } from '../../domain/validation-constraint';
import { ValidationError } from '../../domain/validation-error';

interface TimezoneOption {
	display: string;
	value: string;
	offsetMinutes: number;
}

@Component({
	selector: 'ws-timezone-select',
	templateUrl: './timezone-select.component.html',
})
export class TimezoneSelectComponent implements OnInit {
	@Input() result: any;
	@Input() label: string | undefined;
	@Input() placeholder = '';
	@Input() disabled = false;
	@Input() required = false;
	@Input() readonly = false;
	@Input() errors!: ValidationError[];
	@Input() validationConstraints: ValidationConstraint[] | undefined;
	@Input() model = '';
	@Input() property = '';

	@Output() resultChange = new EventEmitter<string>();

	timezoneOptions: TimezoneOption[] = [];

	ngOnInit(): void {
		this.timezoneOptions = this.buildTimezoneOptions();
	}

	onResultChange(value: string): void {
		this.resultChange.emit(value);
	}

	private buildTimezoneOptions(): TimezoneOption[] {
		const tzNames: string[] = (Intl as any).supportedValuesOf('timeZone');

		return tzNames
			.map((tz) => {
				const offsetMinutes = this.getOffsetMinutes(tz);
				const offsetStr = this.formatOffset(offsetMinutes);
				return { display: `${tz} (UTC${offsetStr})`, value: tz, offsetMinutes };
			})
			.sort((a, b) => a.offsetMinutes - b.offsetMinutes || a.value.localeCompare(b.value));
	}

	private getOffsetMinutes(tz: string): number {
		const now = new Date();
		const utcStr = now.toLocaleString('en-US', { timeZone: 'UTC' });
		const tzStr = now.toLocaleString('en-US', { timeZone: tz });
		return (new Date(tzStr).getTime() - new Date(utcStr).getTime()) / 60000;
	}

	private formatOffset(minutes: number): string {
		if (minutes === 0) return '+00:00';
		const sign = minutes > 0 ? '+' : '-';
		const abs = Math.abs(minutes);
		const h = Math.floor(abs / 60)
			.toString()
			.padStart(2, '0');
		const m = (abs % 60).toString().padStart(2, '0');
		return `${sign}${h}:${m}`;
	}
}
